import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { MsalContext } from "../common/msal";
import cqsLogoImage from './../../img/logo-dark.png';
import logoImage from './../../img/logo.png';

export default class Unauthorized extends React.Component<RouteComponentProps<{}>, {}> {
    static contextType = MsalContext;
    context!: React.ContextType<typeof MsalContext>;

    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    public render() {
        return <div className="card card--login">
            <div className="card-block">
                <form name="form" className="form" onSubmit={this.handleSubmit}>
                    {BQS && <img alt="Brent Quoting System" className="card__logo" src={logoImage} />}
                    {CQS && <img alt="Catalina Quoting System" className="card__logo" src={cqsLogoImage} />}
                    <span className="error-message text-center">You are not authorized to access this site. Please contact Administrator.</span>

                    <div className="row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4 text-center">
                            <button className="btn btn-primary px-4" type="submit">Login with different user</button>
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                </form>
            </div>
        </div>;
    }

    private async handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        const instance = this.context.instance;
        const account = this.context.accounts[0];
        localStorage.removeItem("authorization_token");
        instance.logoutRedirect({ account: account, postLogoutRedirectUri: "/" });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/account/Unauthorized.tsx